define(
	'actions/classes',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes",
	"shared/crm",
	"shared/helpers"
	],
	function($,_,Backbone,React,AppDispatcher,Constants, CRM, Helpers){
		return Backbone.Model.extend({
			STUDENT_CHUNK_SIZE: 32,
			init: function(params) {
			},
			pulling: [],
			dispatchAddClassEvent: function(data) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATED_CLASS,
					data: data
				});
			},
			dispatchUpdateClassEvent: function(guid, data) {
				AppDispatcher.dispatch({
					actionType: Constants.UPDATED_CLASS,
					guid: guid,
					data: data
				});
			},
			dispatchEnrollStudentEvent: function(section_guid, data) {
				AppDispatcher.dispatch({
					actionType: Constants.ENROLL_STUDENT_CLASS,
					class_guid: section_guid,
					data: data
				})
			},
			dispatchDisenrollStudentEvent: function(section_guid, data) {
				AppDispatcher.dispatch({
					actionType: Constants.DISENROLL_STUDENT_CLASS,
					class_guid: section_guid,
					data: data,
				});
			},
			initClass: function(item) {
				return {
					id: item.data.guid,
					name: item.data.display_name,
					code: item.data.enrollment_code,
					students: item.data.students,
					teachers: item.data.teachers,
					status: item.data.state,
					source: item.data.source
				};
			},
			pullClassLink: function(setMessage) {
				var self = this;
				var classes = [];
				api.request('sections/classlink').execute().done(function (response) {
					if (response.data) {
						response.data.forEach(student => {
							classes.push(self.initClass(student));
						})
						self.dispatchAddClassEvent(classes);
					}
				})
				.fail(function (response) {
					if (response.status === 401) {
						setMessage("You are currently not logged into PebbleGo Create. Please log into PebbleGo Create to view your classes");
					} else if (response.status === 422) {
						setMessage("Classes from your ClassLink will be shown here. You do not have any classes.");
					}
				});
			},
			pullClever: function(setMessage) {
				var self = this;
				var classes = [];
				api.request('sections/clever').execute().done(function (response) {
					if (response.data) {
						response.data.forEach(student => {
							classes.push(self.initClass(student));
						})
						self.dispatchAddClassEvent(classes);
					}
				})
				.fail(function (response) {
					if (response.status === 401) {
						setMessage("You are currently not logged into PebbleGo Create. Please log into PebbleGo Create to view your classes");
					} else if (response.status === 422) {
						setMessage("Classes from your Clever will be shown here. You do not have any classes.");
					}
				});
			},
			pull: function(guid) {
				var self = this;
				var classes = [];

				// Pull 
				if(typeof guid == "undefined") {
					api.request('sections').each(function iterator (index, item) {
						classes.push(self.initClass(item));
					}, function () {
						self.dispatchAddClassEvent(classes);
					});
				}
				// Pull from guid
				else if(this.pulling.indexOf(guid) < 0) {
					this.pulling.push(guid);
					api.request('sections', guid).execute().done(function (response) {
						classes.push(self.initClass(response));
					}, function () {
						self.dispatchAddClassEvent(classes);
						self.pulling.slice(self.pulling.indexOf(guid), 1);
					});
				}
			},
			createClass: function(data, success, failure) {
				var self = this;

				var promise = window.api.request("sections").create(data);

				promise.done(function(response) {
					self.dispatchAddClassEvent(self.initClass(response));
					CRM.event('section:create', response.data);

					if(typeof success != "undefined")
						success();
				});

				promise.fail(function(response) {
					if(typeof failure == "function") {
						failure("Failed to create class. Please try again.");
					}
				});
			},
			toggleArchiveClass: function(guid, newStatus, callback) {
				var self = this;

				var ConnectToStores = require("shared/connect-to-stores");
				var section = ConnectToStores.classes.get(guid);
				
				window.api.request("sections", guid).update({data: JSON.stringify({state: newStatus})}).done(function(response) {
					self.dispatchUpdateClassEvent(guid, {status: newStatus});
					CRM.event('section:toggleArchive', {status: newStatus});

					if(typeof callback != "undefined")
						callback();
				});
			},
			updateClassDisplayName: function(guid, display_name) {
				var self = this;

				window.api.request("sections", guid).update({data: JSON.stringify({display_name: display_name})}).done(function(response) {
					self.dispatchUpdateClassEvent(guid, {name: display_name});
					CRM.event('section:rename', {name: display_name});
				});
			},
			bulkEnrollStudents: function(section_guid, user_guids, onSuccess, onFailure) {
				var self = this;

				var ConnectToStores = require("shared/connect-to-stores");
				var section = ConnectToStores.classes.get(section_guid);
				if (Helpers.is_third_party_data(section)) {
					alert("Cannot enroll students to the class created in "+ section.source +".");
					return;
				}

				var data = {
					users: JSON.stringify(user_guids.slice(0, this.STUDENT_CHUNK_SIZE))
				};

				window.api.request("sections", section_guid, "enroll", "bulk")
				.create(data)
				.done(function(response) {
					var section = self.initClass(response);
					self.dispatchEnrollStudentEvent(section_guid, section);

					if (user_guids.length > self.STUDENT_CHUNK_SIZE) {
						self.bulkEnrollStudents(section_guid, user_guids.slice(self.STUDENT_CHUNK_SIZE), onSuccess);
					} else {
						CRM.event('section:bulkenroll', {guid: section_guid});

						if(typeof onSuccess == "function") {
							onSuccess();
						}
					}
				})
				.fail(function (response) {
					console.error(response);
					if (typeof onFailure === "function") {
						onFailure(response);
					}
				})
			},
			bulkDisenrollStudents: function(section_guid, user_guids, callback) {
				var self = this;

				var ConnectToStores = require("shared/connect-to-stores");
				var section = ConnectToStores.classes.get(section_guid);
				if (Helpers.is_third_party_data(section)) {
					alert("Cannot enroll students to the class created in "+ section.source +".");
					return;
				}

				var data = {
					users: JSON.stringify(user_guids.slice(0, this.STUDENT_CHUNK_SIZE))
				};

				window.api.request("sections", section_guid, "disenroll", "bulk").create(data).done(function(response) {
					var section = self.initClass(response);
					self.dispatchDisenrollStudentEvent(section_guid, section);

					if(user_guids.length > self.STUDENT_CHUNK_SIZE) {
						self.bulkDisenrollStudents(section_guid, user_guids.slice(self.STUDENT_CHUNK_SIZE));
					}
					else {
						CRM.event('section:bulkdisenroll', {guid: section_guid});

						if(typeof callback == "function") {
							callback();
						}
					}
				});
			},
			disenrollStudent: function(section_guid, user_guid, callback) {
				var self = this;

				var ConnectToStores = require("shared/connect-to-stores");
				var section = ConnectToStores.classes.get(section_guid);
				if (Helpers.is_third_party_data(section)) {
					alert("Cannot disenroll students from the class created in "+ section.source +".");
					return;
				}

				window.api.request("sections", section_guid, "disenroll").create({user_guid: user_guid}).done(function(response) {
					var section = self.initClass(response);
					self.dispatchDisenrollStudentEvent(section_guid, section);
					CRM.event('section:disenroll', {guid: section_guid});

					if(typeof callback == "function") {
						callback();
					}
				});
			},
			joinClass: function(code, callback) {
				var self = this;

				var promise = window.api.request("sections", code, "enroll").create({});

				promise.done(function(response) {
					var section = self.initClass(response);
					self.dispatchEnrollStudentEvent(section.id, section);
					CRM.event('section:join', {guid: section.id});

					if(typeof callback == "function")
						callback(true);
				});

				promise.fail(function(jqXHR, textStatus, errorThrown) {
					if(typeof callback == "function") {
						callback(false, jqXHR.responseText);
					}
				});
			}
		});
	}
);
